import { useNavigate } from "react-router-dom";
import ScanResults from "../../ScanResults";
import Step1 from "./Step1";
import { languageHomePage } from "../../../../Utils/helpers";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const SmallBusinessInfoTemplate = (props) => {

    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { vendor, activeTab, formFields, handleStep2, createAndDownloadPdf, reportId } = props;

    const [homeLink, setHomeLink] = useState("/home");

    useEffect(() => {
        setHomeLink(languageHomePage(i18n.language));
    }, [i18n.language]);

    return (
        <>

            <div className="performace-bg">
                <div className='main_wrapper '>
                    <div className="performance-local">
                        <div className="performace-logo">
                            <img onClick={(e) => navigate(homeLink)} src={vendor?.logo} alt="" />
                        </div>

                        {
                            (activeTab === 1 || activeTab === 2) ? <>
                                <Step1 vendor={vendor} formFields={formFields} onSubmit={handleStep2} />
                            </> : null
                        }

                        {
                            (activeTab === 3) ? <>
                                <ScanResults vendor={vendor} createAndDownloadPdf={createAndDownloadPdf} reportId={reportId} />
                            </> : null
                        }


                    </div>
                </div>
            </div>

            <div className="copyright-footer-sec">
                <p>Copyright @ {(new Date())?.getFullYear()}, {vendor?.name}. All Rights Reserved.</p>
            </div>

        </>
    );
}

export default SmallBusinessInfoTemplate;